export default "__VITE_ASSET__ae5691a4__"